import React, { Component } from "react";
class cgu extends Component {
  render() {
    return (
      <p>
        Les présentes Conditions Générales d'Utilisation seront complétées par
        les Conditions Générales de Vente lors de la commercialisation de la
        version aboutie de la Plateforme Digitale, étant précisé que l'achat du
        Pilote de la Plateforme Digitale est régi par le contrat signé entre
        HAPPY QUEST et l'entreprise employant l'Utilisateur de la Plateforme
        Digitale, étant précisé que ce contrat est disponible au siège de ladite
        entreprise.
        <br /> Les présentes Conditions Générales d'Utilisation (complétées
        comme indiqué ci-dessus) prévalent sur tout autre accord ou contrat
        éventuellement conclu entre HAPPY QUEST et l'Utilisateur. HAPPY QUEST
        <br /> SAS au capital de 5 000 €<br /> RCS Paris n° 833928310
        <br /> Siège social : 303 rue du Faubourg Saint-Antoine
        <br /> CONDITIONS GENERALES D'UTILISATION DE HAPPY QUEST POUR UNE
        UTILISATION NON PROFESSIONNELLE Applicables à compter du 08/01/2018
        <br />
        <br /> I. OBJET ET CHAMP D'APPLICATION
        <br /> La société HAPPY QUEST (RCS Paris n°833928310) propriétaire de la
        marque HAPPY QUEST, édite la plateforme digitale du même nom (ci-après «
        Plateforme Digitale ») qui a pour objet de la réalisation de prestations
        de services, notamment via un parcours pédagogique digital et ludique,
        permettant notamment de favoriser ou d'améliorer le bien-être au travail
        des individus. Dans le cadre de la finalisation de la Plateforme
        Digitale, HAPPY QUEST a développé un pilote de la Plateforme Digitale
        (ci-après « ci- après « le Pilote de la Plateforme Digitale » ou « le
        Pilote ») et souhaite désormais le tester directement auprès des
        salariés d'une même entreprise en situation réelle, afin notamment
        d'améliorer les caractéristiques de la Plateforme Digitale.
        <br /> Les présentes Conditions Générales d'Utilisation ont pour objet
        de fixer les règles d'utilisation de la Plateforme Digitale et du Pilote
        de la Plateforme Digitale par l'Utilisateur. Ainsi, l'Utilisateur
        s'engage à respecter les présentes Conditions Générales d'Utilisation à
        chacune de ses utilisations du Pilote de la Plateforme Digitale et de la
        Plateforme Digitale dans sa version aboutie. En conséquence,
        l'Utilisateur accepte, pleinement et sans aucune réserve, l'ensemble des
        présentes Conditions Générales d'Utilisation avant tout téléchargement
        de la Plateforme Digitale, en cochant la case désignant la phrase « Je
        certifie être majeur(e) et avoir lu et accepté les Conditions Générales
        d'Utilisation de HAPPY QUEST » située au bas de la page d'inscription
        pour la valider.
        <br /> Digitale, sous réserve que celles-ci aient été communiquées au
        moment de la dernière mise à jour de la Plateforme Digitale. A défaut,
        les Conditions Générales d'Utilisation applicables sont celles
        applicables au jour du téléchargement de la Plateforme Digitale.
        <br />
        <br /> II. DEFINITIONS
        <br /> Dans les présentes Conditions Générales d'Utilisation, les mots
        ou expressions commençant avec une majuscule auront la signification
        suivante
        <br /> :<br /> Plateforme Digitale désigne le site internet, incluant sa
        version mobile et tablette ainsi que toutes déclinaisons futures, édité
        par HAPPY QUEST et porteur du Programme HAPPY QUEST telle que décrite à
        l'article I des présentes conditions Générales d'Utilisation et
        accessibles notamment à partir du smartphone des salariés de
        l'entreprise partenaire de HAPPY QUEST. HAPPY QUEST désigne la société
        propriétaire de l'ensemble des droits afférents à la Plateforme
        <br /> Digitale et son Pilote, et identifiée en tête des
        <br /> présentes Conditions Générales d'Utilisation.
        <br /> Cookie désigne un petit fichier d'informations
        <br /> qu'un site Web peut envoyer sur le disque dur d'un
        <br /> ordinateur personnel pour ensuite en retrouver la
        <br /> trace.
        <br /> Données désigne les informations et données
        <br /> personnelles (i.e données identifiant directement ou
        <br /> indirectement une personne physique)
        <br /> communiquées par l'Utilisateur lors de son
        <br /> inscription et dans le cadre de l'utilisation du Pilote
        <br /> de la Plateforme Digitale.
        <br /> Entreprise Partenaire désigne la société qui a conclu un contrat
        de prestation de services avec
        <br /> HAPPY QUEST afin que ses salariés puissent
        <br /> utiliser la Plateforme Digitale et son Pilote.
        <br /> Identifiants désigne l'identifiant propre de
        <br /> l'utilisateur ("login") et le mot de passe de
        <br /> connexion ("password").
        <br /> Le Pilote désigne la version non encore aboutie de
        <br /> la Plateforme Digitale en phase de test par un panel
        <br /> de salariés d'une Entreprise Partenaire.
        <br /> Profil désigne les informations communiquées par
        <br /> l'Utilisateur lors de son inscription ou lors d'une
        <br /> connexion, à savoir ses données personnelles
        <br /> nécessaires à l'utilisation de la Plateforme Digitale
        <br /> et son Pilote.
        <br /> Service Clients désigne le service d'information et
        <br /> d'assistance mis à la disposition des Utilisateurs par
        <br /> HAPPY QUEST. Le Service Clients peut être
        <br /> contacté par voie postale à l'adresse suivante 303
        <br /> rue du Faubourg Saint-Antoine 75011 Paris ou par
        <br /> email à l'adresse : contact@happyquest.co.
        <br /> HAPPY QUEST est libre de modifier les Conditions Générales
        d'Utilisation à tout moment. Il est donc conseillé à l'Utilisateur de se
        référer, régulièrement, à la dernière version des Conditions Générales
        d'Utilisation disponible en permanence à l'adresse suivante :
        www.happyquest.co
        <br /> Les Conditions Générales d'Utilisation applicables sont celles en
        vigueur à la date d'utilisation du Pilote de la Plateforme Digitale et
        de la Plateforme
        <br />
        <br /> HAPPY QUEST
        <br /> SAS au capital de 5 000 €<br /> RCS Paris n° 833928310
        <br /> Siège social : 303 rue du Faubourg Saint-Antoine
        <br /> Site Internet désigne le site Internet www.happyquest.co édité
        par la société HAPPY QUEST.
        <br /> Utilisateur désigne le salarié placé sous la responsabilité d'une
        Entreprise Partenaire et bénéficiant d'un accès à la Plateforme Digitale
        et/ou son Pilote, quel que soit le lieu où elle se trouve et les
        modalités de sa connexion à la Plateforme Digitale.
        <br /> <br /> III. DESCRIPTION DU PRODUIT
        <br /> L'Utilisateur qui aura téléchargé le Pilote de la Plateforme
        Digitale et créé un compte pourra :<br /> - Répondre à des quiz,
        réaliser des challenges, gagner des récompenses, notamment des citations
        sur le thème du bien-être au travail ;<br /> - Suivre l'évolution de son
        bien-être au travail en répondant à des questions ;<br /> HAPPY QUEST
        pourra apporter des améliorations aux services listés ci-dessus en
        fonction notamment des retours des Entreprises Partenaires et des
        Utilisateurs, et ce sans frais pour les Entreprises Partenaires. Les
        Utilisateurs devront alors télécharger la mise à jour du pilote de la
        Plateforme Digitale pour bénéficier de ces améliorations.
        <br /> Lors de sa connexion au Pilote de la Plateforme Digitale,
        l'Utilisateur a été dûment informé(e) :<br /> - le Pilote de la
        Plateforme Digitale ne dispose pas de toutes les fonctionnalités de la
        version définitive de la Plateforme Digitale, et/ou que certaines de ces
        fonctionnalités ne sont pas optimales, et pourront être sujettes à des
        fortes évolutions et améliorations,
        <br /> - que le Pilote de la Plateforme Digitale peut connaître des
        dysfonctionnements et des bugs,
        <br /> - que l'utilisation du Pilote de la Plateforme Digitale peut
        entraîner des anomalies.
        <br /> En conséquence, l'Utilisateur reconnaît et accepte que HAPPY
        QUEST est soumise à une obligation de moyen quant à la fourniture des
        services décrits au présent article III.
        <br />
        <br /> IV. ACCES ET UTILISATION DE LA PLATEFORME DIGITALE
        <br /> 4.1. Le téléphone et les frais de télécommunications induits par
        l'utilisation de la Plateforme Digitale sont à la charge exclusive de
        l'Utilisateur et/ou de l'Entreprise Partenaire. Il appartient à
        l'Utilisateur de prendre toutes les mesures appropriées de façon à
        protéger ses propres données et/ou logiciels contenus dans son
        smartphone.
        <br /> 4.2. Lors du téléchargement de la Plateforme Digitale et/ou de
        son Pilote, l'Utilisateur s'engage à fournir des informations vraies,
        exactes et complètes et donc à les tenir à jour sans délais. Dans
        l'hypothèse où l'Utilisateur fournirait des informations fausses,
        inexactes, périmées ou incomplètes, HAPPY QUEST est en droit de
        suspendre ou de lui refuser, immédiatement et pour le futur, l'accès à
        tout ou partie de la Plateforme Digitale et/ou de son Pilote, et ce,
        dans les conditions visées dans les Conditions Générales de Vente ou le
        contrat conclu entre Happy Quest et
        <br /> l'Entreprise Partenaire.
        <br /> 4.3. Pour créer son compte, l'Utilisateur devra être inscrit sur
        la liste fournie par l'Entreprise Partenaire à HAPPY QUEST et
        télécharger le Pilote de la Plateforme Digitale sur son téléphone
        portable. A partir de son téléphone portable, il devra ensuite donner
        les renseignements suivants :<br /> - Adresse e-mail professionnelle
        <br /> - Son prénom,
        <br /> - Son nom de famille,
        <br /> - Son mot de passe.
        <br /> Sous réserve du téléchargement de la Plateforme
        <br /> Digitale et/ou de son Pilote sur son téléphone
        <br /> mobile et de la création de son compte, l'Utilisateur
        <br /> pourra se connecter à tout moment, à l'aide de ses
        <br /> Identifiants, à l'exception des périodes de
        <br /> maintenance. A savoir :<br /> - 24 heures sur 24,
        <br /> - 7 jours sur 7,
        <br /> - y compris les dimanche et jours fériés.
        <br /> L'accès s'effectue à partir de son téléphone portable uniquement.
        <br /> 4.4. HAPPY QUEST accorde à l'Utilisateur un droit
        <br /> de consultation, d'utilisation et d'accès aux
        <br /> informations présentes sur le Site Internet dans les
        <br /> conditions suivantes :<br /> De manière générale, et sans que
        cette liste puisse
        <br /> être considérée comme exhaustive, l'Utilisateur
        <br /> s'engage à :<br /> • ne télécharger les informations sur son
        équipement que pour un usage exclusivement personnel, non marchand et
        limité dans le temps ; n'imprimer les informations téléchargées sur
        support papier qu'à la condition que les copies ainsi constituées
        fassent l'objet d'un usage exclusivement personnel, ce qui exclut
        notamment toute reproduction à des fins professionnelles ou commerciales
        ou de diffusion en nombre, gratuite ou payante ;<br /> • ne pas
        conserver les informations téléchargées plus de quarante-huit (48)
        heures et procéder à leur destruction passé ce délai ;<br />
        <br /> HAPPY QUEST
        <br /> SAS au capital de 5 000 €<br /> RCS Paris n° 833928310
        <br /> Siège social : 303 rue du Faubourg Saint-Antoine
        <br /> 5.1. L'Utilisateur choisit ses Identifiants. Les Identifiants
        sont personnels et confidentiels, ils sont destinés à réserver l'accès
        de la Plateforme Digitale et/ou de son Pilote aux seuls clients de HAPPY
        QUEST, à protéger l'intégrité et la disponibilité de la Plateforme
        Digitale et de son Pilote, ainsi que l'intégrité, la disponibilité et la
        confidentialité des Données telles que transmises par les Utilisateurs.
        L'Utilisateur s'engage à conserver ses Identifiants secrets et
        s'interdit de les divulguer sous quelque forme que ce soit à des tiers.
        Les Identifiants ne pourront être modifiés que sur demande de
        l'Utilisateur, ou à l'initiative de HAPPY QUEST sous réserve d'en
        informer préalablement l'Utilisateur.
        <br /> • à ne pas recopier tout ou partie du Site Internet sur un autre
        site ou un réseau interne
        <br /> d'entreprise ;<br /> • ne pas reproduire ou résumer la version
        <br /> numérique des informations à des fins de revue ou de panorama de
        presse sauf accord écrit et préalable de HAPPY QUEST;
        <br /> • ne pas réaliser une revue ou un panorama de presse à partir des
        informations ou photographies signalées comme appartenant à un
        prestataire tiers, ni à réutiliser ces informations pour les proposer
        sur quelque support que ce soit en dehors du strict cadre légal de la
        copie privée ;<br /> • ne pas reproduire, résumer, altérer, modifier,
        déplacer, retirer, remplacer ou rediffuser, sans autorisation écrite et
        préalable de HAPPY QUEST, le contenu éditorial des informations [texte
        (articles, titre,...) et/ou reproduction (illustrations, photos ...)]
        et/ou le nom, le logo, la marque HAPPY QUEST et/ou des Titulaires et/ou
        toute autre information se rapportant aux droits de HAPPY QUEST ;<br />{" "}
        • ne pas extraire ou réutiliser, y compris à des fins privées, sans
        autorisation écrite et préalable de HAPPY QUEST, une partie
        substantielle ou non du contenu des bases de données et archives
        constituées par le Site Internet;
        <br /> • à mettre en place des systèmes de contrôle adaptés en fonction
        des évolutions techniques pour éviter tout "piratage" des informations
        et en particulier pour éviter l'utilisation illicite ou contraire aux
        présentes Conditions Générales d'Utilisation de toute information de
        quelque manière et sous quelque forme que ce soit ;<br /> • à informer
        HAPPY QUEST dès la connaissance d'un " piratage " et en particulier de
        toute utilisation illicite ou non-contractuelle des informations et ce
        quel que soit le mode de diffusion utilisé.
        <br /> La violation de ces dispositions impératives soumet l'Utilisateur
        ainsi que toutes les personnes qui y ont participé aux sanctions pénales
        et civiles prévues par la loi.
        <br /> 4.5. HAPPY QUEST concède aux Utilisateurs un droit personnel, non
        exclusif, non cessible et non transférable d'utilisation de la
        Plateforme Digitale et de son Pilote, pendant toute la durée de son
        utilisation et pour le monde entier.
        <br /> Les Utilisateurs ne pourront en aucun cas mettre la Plateforme
        Digitale ou son Pilote à disposition d'un tiers, et s'interdit
        strictement toute autre utilisation, en particulier toute adaptation,
        modification, traduction, arrangement, diffusion, ou décompilation.
        <br /> V. UTILISATION DES DONNEES PERSONNELLES ET RESPECT DE LA VIE
        PRIVEE
        <br /> L'Utilisateur est entièrement responsable de l'utilisation des
        Identifiants le concernant. Sauf preuve contraire, toute connexion à la
        Plateforme
        <br /> Digitale et/ou à son Pilote, ou transmission de
        <br /> données effectuées à partir des Identifiants de
        <br /> l'Utilisateur sera réputée avoir été effectuée par ce
        <br /> dernier.
        <br /> A cet égard, l'Utilisateur a la possibilité de s'assurer
        <br /> qu'à l'issue de chaque session, il peut se
        <br /> déconnecter explicitement. En cas de perte, de vol
        <br /> ou de divulgation accidentelle de ses Identifiants,
        <br /> l'Utilisateur doit en informer sans délai, le Service
        <br /> Clients, par courrier électronique ou postal, qui
        <br /> procèdera alors à l'annulation dans les meilleurs
        <br /> délais des Identifiants de l'Utilisateur. L'Utilisateur
        <br /> recevra un nouveau mot de passe. Toute perte, vol,
        <br /> détournement ou utilisation non autorisée des
        <br /> Identifiants et leurs conséquences relèvent de la
        <br /> responsabilité de l'Utilisateur. L'ouverture d'une
        <br /> nouvelle session par des Identifiants déjà en cours
        <br /> d'utilisation entraînera automatiquement la
        <br /> fermeture de la 1ère session ouverte.
        <br /> HAPPY QUEST respecte la vie privée des Utilisateurs et se
        conforme strictement aux lois en
        <br /> vigueur sur la protection de la vie privée et des
        <br /> libertés individuelles. Ainsi, les données
        <br /> personnelles transmises par chaque Utilisateur,
        <br /> notamment au moment de sa connexion au Pilote
        <br /> de la Plateforme Digitale, à la Plateforme Digitale
        <br /> et de chacune de ses mises à jour, de sa navigation
        <br /> sur la Plateforme Digitale, ou (ii) encore de sa
        <br /> navigation sur le Site Internet, sont destinées à la
        <br /> réalisation de prestations de services, notamment
        <br /> via un parcours pédagogique digital et ludique,
        <br /> permettant notamment de favoriser ou d'améliorer
        <br /> le bien-être au travail des individus. HAPPY
        <br /> QUEST pourra également, sous réserve des
        <br /> dispositions légales et réglementaires applicables,
        <br /> utiliser les Données afin d'établir des statistiques à<br />
        <br />
        <br /> HAPPY QUEST
        <br /> SAS au capital de 5 000 €<br /> RCS Paris n° 833928310
        <br /> Siège social : 303 rue du Faubourg Saint-Antoine
        <br /> des fins (i) d'améliorations des services offerts par la
        Plateforme Digitale, (ii) de présentation des services proposés par
        HAPPY QUEST. L'hébergement des Données offre un niveau de protection
        suffisant au regard des recommandations de la Commission Nationale de
        l'Informatique et des Libertés (CNIL). La Plateforme Digitale a fait
        l'objet de la déclaration CNIL [] par Happy Quest, qui en est le
        responsable de traitement.
        <br /> HAPPY QUEST s'engage à mettre en œuvre les moyens techniques
        appropriés pour assurer la sécurité des Données et préserver l'intégrité
        et la confidentialité des Données contenues dans la Plateforme Digitale.
        HAPPY QUEST met en place les mesures techniques et organisationnelles de
        nature à empêcher tout accès ou utilisations frauduleuses des Données et
        à prévenir toutes pertes, altérations et destructions des Données.
        <br /> En application des dispositions de la loi n° 78-17 du 6 janvier
        1978, modifiée par la loi n° 2004-801 du 7 août 2004, relative à
        l'informatique, aux fichiers et aux libertés, chaque Utilisateur dispose
        d'un droit d'opposition, d'accès, de rectification et de suppression des
        données le concernant. Chaque Utilisateur peut exercer ce droit en ligne
        à tout moment en allant sur Internet à l'adresse suivante :
        www.happyquest.co ou en écrivant au Service Clients par e-mail ou voie
        postale.
        <br />
        <br /> VI. PROPRIETE INTELLECTUELLE DE HAPPY QUEST
        <br /> 6.1. HAPPY QUEST est et demeure propriétaire de l'ensemble des
        Données qui lui sont transmises par les Utilisateurs.
        <br /> 6.2. HAPPY QUEST est titulaire de la marque HAPPY QUEST déposée
        auprès de l'Institut National de la Propriété Industrielle (INPI). Par
        conséquent, HAPPY QUEST est seule propriétaire de l'intégralité des
        droits de propriété intellectuelle sur ladite marque, ce que LE CLIENT
        reconnaît.
        <br /> 6.3. HAPPY QUEST est et demeure seule titulaire de l'ensemble des
        droits de propriété intellectuelle portant sur la Plateforme Digitale
        (en ce compris son Pilote et les développements de la Plateforme
        Digitale auxquels elle procèdera), sur la structure et le contenu de la
        Plateforme Digitale, et sur toute la technologie développée dans le
        cadre de la création et de la fabrication de ladite Application. HAPPY
        QUEST est donc seule en mesure de faire protéger ou non ses droits de
        propriété industrielle sur son Application, par un brevet ou tout autre
        titre de propriété intellectuelle, ce que LE CLIENT reconnaît.
        <br /> 6.4. Le présent Contrat n'entraîne le transfert d'aucun droit de
        propriété intellectuelle au profit du CLIENT. Ainsi, LE CLIENT s'engage
        à ne pas utiliser le pilote et/ou la Plateforme Digitale de manière à
        porter atteinte aux droits de HAPPY QUEST et à ce que cette utilisation
        ne constitue pas une contrefaçon ou une concurrence déloyale ou
        parasitaire.
        <br /> ou parasitaire des Informations.
        <br /> <br /> VII. LIMITATION DE RESPONSABILITE
        <br /> HAPPY QUEST ne saurait être tenue responsable de tout
        dysfonctionnement du Pilote et/ou de la Plateforme Digitale, ni de toute
        interruption et/ou bug de la Plateforme Digitale liés à ou résultant
        d'un cas de force majeure, tel que défini par la jurisprudence
        française.
        <br /> HAPPY QUEST ne saurait être tenue responsable d'un quelconque
        dommage subi au titre de l'utilisation du Pilote et/ou de la Plateforme
        Digitale (i) si ce dommage résulte, en tout ou en
        <br /> partie, de l'action ou de l'omission de l'Utilisateur
        <br /> et/ou de tout tiers (si l'Utilisateur ne télécharge pas
        <br /> les mises à jour conseillées par exemple, etc.), (ii) si
        <br /> ce dommage est dû à une incompatibilité technique
        <br /> entre les équipements de l'Utilisateur et ceux du
        <br /> Pilote de la Plateforme Digitale et/ou de la
        <br /> Plateforme Digitale.
        <br /> HAPPY QUEST ne saurait être tenue responsable
        <br /> d'un dysfonctionnement de la Plateforme Digitale,
        <br /> si celui-ci est dû à des facteurs ne dépendant pas du
        <br /> Pilote de la Plateforme Digitale ou de la Plateforme
        <br /> Digitale elle-même (tels qu'une défaillance des
        <br /> fournisseurs d'accès à Internet etc.). De même,
        <br /> HAPPY QUEST ne sera pas tenue responsable de
        <br /> tout dommage résultant d'une défaillance
        <br /> fonctionnelle du smartphone, support de la
        <br /> Plateforme Digitale.
        <br /> Au vu du caractère non abouti du Pilote de la
        <br /> Plateforme Digitale, parfaitement connu par
        <br /> l'Utilisateur, la responsabilité de HAPPY QUEST
        <br /> ne saurait être engagée pour tout dysfonctionnement inhérent aux
        risques potentiels
        <br /> identifiés à l'article III intitulé « Description du
        <br /> Produit ».
        <br /> L'Utilisateur reconnaît utiliser le Pilote de la
        <br /> Plateforme Digitale et la Plateforme Digitale à ses
        <br /> seuls risques et périls.
        <br /> L'Utilisateur admet, compte tenu de la nature du
        <br /> Pilote de la Plateforme Digitale et de la Plateforme
        <br /> Digitale, que HAPPY QUEST peut être amenée à<br /> modifier sans
        préavis le contenu de la Plateforme
        <br /> Digitale, sous réserve d'en informer l'Utilisateur au
        <br /> plus tard dans les 15 jours suivant la mise en œuvre
        <br /> de cette modification.
        <br /> Enfin, si l'Utilisateur contracte avec des annonceurs
        <br /> via la Plateforme Digitale, HAPPY QUEST
        <br /> n'assume aucune obligation ou responsabilité
        <br />
        <br /> HAPPY QUEST
        <br /> SAS au capital de 5 000 €<br /> RCS Paris n° 833928310
        <br /> Siège social : 303 rue du Faubourg Saint-Antoine
        <br /> Certains services personnalisés du Site Internet utilisent, pour
        leur bon fonctionnement, des Cookies temporaires et requièrent
        l'acceptation par l'Utilisateur de ces Cookies. Si le navigateur de
        l'ordinateur personnel de l'Utilisateur est configuré pour les refuser,
        l'accès à ces services peut se révéler altéré, voire impossible. Les
        cookies utilisés sur le Site Internet permettent également d'identifier
        les services et rubriques que l'Utilisateur a visités, et plus
        généralement son comportement en matière de visites. Ces informations
        sont utiles pour mieux personnaliser les services, contenus, offres et
        bannières qui apparaissent sur le Site Internet. L'Utilisateur peut
        désactiver les Cookies ou les supprimer en utilisant les options de son
        navigateur. Chaque navigateur étant différent, l'Utilisateur est invité
        à consulter la notice de son navigateur pour le paramétrer à sa
        convenance. La durée de conservation de ces informations dans
        l'ordinateur de l'Utilisateur est de douze (12) mois à compter de leur
        placement.
        <br /> concernant la délivrance des produits et services proposés par
        ses partenaires commerciaux.
        <br /> <br /> VIII. COOKIES
        <br /> exclusive des juridictions compétentes du ressort de la Cour
        d'appel de Paris, même en cas de demande incidente ou en garantie ou de
        pluralité de défendeurs.
        <br /> IX. DISPOSITIONS DIVERSES
        <br /> 9.1. Si l'une quelconque des dispositions des présentes
        Conditions Générales d'Utilisation était déclarée nulle ou inapplicable
        en application d'une loi, d'un règlement ou à la suite d'une décision de
        justice devenue définitive, elle serait réputée non écrite et les autres
        dispositions resteraient en vigueur.
        <br /> 9.2. Les relations contractuelles entre HAPPY QUEST et
        l'Utilisateur sont régies par les seules dispositions des présentes
        Conditions Générales d'Utilisation, complétées comme il est indiqué à
        l'article I ci-dessus.
        <br /> 9.3. L'Utilisateur ne peut pas céder tout ou partie des droits et
        obligations résultant des Conditions Générales d'Utilisation qu'après
        accord préalable et écrit de HAPPY QUEST.
        <br />
        <br /> X. LOI APPLICABLE ET ATTRIBUTION DE JURIDICTION
        <br /> 10.1. Les présentes Conditions Générales d'Utilisation sont
        soumises à tous égards au droit français.
        <br /> Elles ont été rédigées en langue française qui sera considérée,
        en toute hypothèse, comme la langue unique.
        <br /> 10.2. Les parties conviennent de faire leur possible pour
        résoudre à l'amiable toute contestation susceptible de résulter de
        l'interprétation, de l'exécution et/ou de la cessation des présentes
        Conditions Générales d'Utilisation. A défaut, ladite contestation sera
        soumise à la compétence
      </p>
    );
  }
}

export default cgu;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/cgu.js